import { render, staticRenderFns } from "./HsabExpenseFormRecipients.vue?vue&type=template&id=0d24bafa&scoped=true"
import script from "./HsabExpenseFormRecipients.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseFormRecipients.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseFormRecipients.vue?vue&type=style&index=0&id=0d24bafa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24bafa",
  null
  
)

export default component.exports